import { render } from "./ReportBoard.vue?vue&type=template&id=24d25f07"
import script from "./ReportBoard.vue?vue&type=script&lang=js"
export * from "./ReportBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__